
<!-- ****************  Editable verticle table with one editable column ********-->

<div >
    <table class="table table-bordered" style="border-collapse: collapse; width: 100%;margin:0;">
        <tbody>
            <ng-container *ngIf="columns && columns.length">
                <tr *ngFor="let i of array(Math.ceil(columns.length / columnsPerRow)).fill(0); let rowIndex = index">
                    <ng-container *ngFor="let j of [].constructor(columnsPerRow); let colIndex = index">
                        <td *ngIf="columns[rowIndex * columnsPerRow + colIndex]"
                            style="border: 1px solid black; padding: 10px; background-color: #f3e8ff99; font-weight: bold; text-align: left; width: 250px;">
                            {{ columns[rowIndex * columnsPerRow + colIndex].name }}
                        </td>
                        <td *ngIf="data && data.length > 0 && columns[rowIndex * columnsPerRow + colIndex]"
                            style="border: 1px solid black; padding: 8px;">

                            <div *ngIf="editingEnabled">
                                <ng-container [ngSwitch]="columns[rowIndex * columnsPerRow + colIndex]?.type">
                                    
                                    <select *ngSwitchCase="'boolean'" [(ngModel)]="data[0][columns[rowIndex * columnsPerRow + colIndex]?.field]" 
                                        class="clr-input" (ngModelChange)="validateField(columns[rowIndex * columnsPerRow + colIndex]?.field, 'boolean',0,data[0])">
                                        <option [value]="true">True</option>
                                        <option [value]="false">False</option>
                                    </select>
                            
                                    <!-- Textarea for Custom Type -->
                                    <textarea *ngSwitchCase="'custom'" [(ngModel)]="data[0][columns[rowIndex * columnsPerRow + colIndex]?.field]" 
                                        class="clr-input" (ngModelChange)="validateField(columns[rowIndex * columnsPerRow + colIndex]?.field, 'custom',0,data[0])">
                                    </textarea>
                            
                                    <!-- Select Dropdown -->
                                    <select *ngSwitchCase="'select'" [(ngModel)]="data[0][columns[rowIndex * columnsPerRow + colIndex]?.field]" 
                                        class="clr-input" (ngModelChange)="validateField(columns[rowIndex * columnsPerRow + colIndex]?.field, 'select',0,data[0])">
                                        <option *ngFor="let option of columns[rowIndex * columnsPerRow + colIndex]?.options" 
                                            [value]="option.value">{{ option.label }}
                                        </option>
                                    </select>
                            
                                    <!-- Number Input -->
                                    <input *ngSwitchCase="'number'" [(ngModel)]="data[0][columns[rowIndex * columnsPerRow + colIndex]?.field]" 
                                        type="number" class="clr-input" min="0" 
                                        (ngModelChange)="validateField(columns[rowIndex * columnsPerRow + colIndex]?.field, 'number',0,data[0])" />
                            
                                    <!-- Default Input -->
                                    <input *ngSwitchDefault [(ngModel)]="data[0][columns[rowIndex * columnsPerRow + colIndex]?.field]" 
                                        [type]="columns[rowIndex * columnsPerRow + colIndex]?.type || 'text'" 
                                        class="clr-input" (ngModelChange)="validateField(columns[rowIndex * columnsPerRow + colIndex]?.field, columns[rowIndex * columnsPerRow + colIndex]?.type,0,data[0])" />
                                
                                
                                    </ng-container>
                            
                                <!-- Error Display -->
                                <div *ngIf="errors && errors[0] && errors[0][columns[rowIndex * columnsPerRow + colIndex]?.field]" 
                                    class="error-message" style="margin-left: 1.2em;">
                                    {{ errors[0][columns[rowIndex * columnsPerRow + colIndex]?.field] }}
                                </div>
                            </div>
                            
                            <ng-container *ngIf="!editingEnabled">
                                <ng-container *ngIf="columns[rowIndex * columnsPerRow + colIndex].unit">
                                    <ng-container [ngSwitch]="columns[rowIndex * columnsPerRow + colIndex].unit">

                                        <ng-container *ngSwitchCase="'percentage'">
                                            <span>
                                                {{ data[0][columns[rowIndex * columnsPerRow + colIndex].field]
                                                ? (data[0][columns[rowIndex * columnsPerRow + colIndex].field] | number:
                                                '1.2-2') + '%'
                                                : '0%' }}
                                            </span>
                                        </ng-container>

                                        <ng-container *ngSwitchCase="'currency'">
                                            <span>
                                                {{formatCurrency(data[0][columns[rowIndex * columnsPerRow + colIndex].field])}}
                                               
                                            </span>
                                        </ng-container>

                                        <ng-container *ngSwitchCase="'time'">
                                            <span>
                                                {{ data[0][columns[rowIndex * columnsPerRow + colIndex].field]
                                                ? (data[0][columns[rowIndex * columnsPerRow + colIndex].field] | number:
                                                '1.2-2') + ' ms'
                                                : '0 ms' }}
                                            </span>
                                        </ng-container>

                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="!columns[rowIndex * columnsPerRow + colIndex].unit">
                                    <ng-container
                                        *ngIf="columns[rowIndex * columnsPerRow + colIndex].type === 'number'">
                                        {{ formatNumber(data[0][columns[rowIndex * columnsPerRow + colIndex].field]) || 'N/A' }}
                                    </ng-container>

                                    <ng-container *ngIf="columns[rowIndex * columnsPerRow + colIndex].type === 'date'">
                                        {{ data[0][columns[rowIndex * columnsPerRow + colIndex].field]
                                        ? (data[0][columns[rowIndex * columnsPerRow + colIndex].field] |
                                        date:'MM/dd/yyyy')
                                        : 'N/A' }}
                                    </ng-container>

                                    <ng-container *ngIf="columns[rowIndex * columnsPerRow + colIndex].type === 'text'">
                                        {{ data[0][columns[rowIndex * columnsPerRow + colIndex].field] || 'N/A' }}
                                    </ng-container>

                                    <ng-container
                                        *ngIf="columns[rowIndex * columnsPerRow + colIndex].type === 'boolean'">
                                        {{ data[0][columns[rowIndex * columnsPerRow + colIndex].field] ? 'Yes' : 'No' }}
                                    </ng-container>

                                    <ng-container
                                        *ngIf="columns[rowIndex * columnsPerRow + colIndex].type === 'custom'">
                                        <div
                                            [innerHTML]="renderCell({'field': columns[rowIndex * columnsPerRow + colIndex].field, 'data': data[0]})">
                                        </div>
                                    </ng-container>

                                </ng-container>
                            </ng-container>

                            <!-- <ng-container *ngIf="!editingEnabled">
                                {{ data[0][columns[rowIndex * columnsPerRow + colIndex]?.field] || 'NA' }}
                            </ng-container> -->
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
        </tbody>
    </table>


    <div style="display: flex; justify-content: flex-end; align-items: center; margin-top: 10px;">
        <div>
            <!-- <label *ngIf="tableTitle" class="me-2">{{ tableTitle }}</label> -->
            <button (click)="toggleEditing()" class="btn btn-primary">
                {{ editingEnabled ? 'Save' : 'Edit' }}
            </button>
            <button *ngIf="editingEnabled" (click)="discardChanges()" style="margin-left: 5px;"
                class="btn btn-danger">Cancel</button>
        </div>
    </div>
</div>